<template>
    <div>
        <span v-if="savedResource">
            <b-icon-bookmark-fill></b-icon-bookmark-fill>
        </span>
        <span v-else>
            <b-icon-bookmark></b-icon-bookmark>
        </span>
    </div>
</template>

<script>
import { BIconBookmark, BIconBookmarkFill } from 'bootstrap-vue';

export default {
    name: 'BookmarkResource',
    components: {
        BIconBookmark,
        BIconBookmarkFill,
    },
    props: {
        resourceInfo: Number,
        userInfo: Object,
    },
    data() {
        return {};
    },
    computed: {
        savedResource() {
            // console.log('how many times do i get called');
            console.log('this is the individual console id ', this.resourceInfo);
            // console.log('weird');
            console.log('this is the userInfo object ', this.userInfo);
            // console.log('these are the saved resources ', Object.values(this.userInfo));
            const saved = Object.values(this.userInfo);
            if (saved.includes(this.resourceInfo)) {
                return true;
            }
            return false;
        },
    },
};
</script>

<style scoped>
</style>
